import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/blocks/TitleNewsBlock/TitleNewsBlock.tsx");
